import React, { useState } from "react";
import { MediaContext } from "./MediaContext";

const MediaProvider = (props) => {
  const setPlayingVideo = (event) => {
    if (settings.isYoutubePlaying && event.target !== settings.youtubeVideoPlaying) {
      settings.youtubeVideoPlaying.pauseVideo();
    }
    // @NOTE not using youtubePlayingId now
    const updatedTarget = Object.assign({}, settings, {
      isYoutubePlaying: true,
      youtubeVideoPlaying: event.target,
      youtubePlayingId: event.target.getVideoUrl(),
    });
    updateSettings(updatedTarget);
  };

  const [settings, updateSettings] = useState({
    isYoutubePlaying: false,
    youtubePlayingId: "",
    setPlayingVideo,
  });

  return (
    <MediaContext.Provider
      value={{
        settings: settings,
        setPlayingVideo: setPlayingVideo,
      }}
    >
      {props.children}
    </MediaContext.Provider>
  );
};

export default MediaProvider;
